import { z } from 'zod';
import { AlertSchema } from './alerts.js';
import { EventSchema } from './events.js';
import { AlertNotifiedMessageSchema } from './notifications.js';
import { SOURCE_STATUSES } from './sources.js';
/**
 * Server-Sent Events, TechSpec §7. `event:` names and `data:` payloads.
 * `id:` is the Redis stream entry id; the client echoes the last one it saw as
 * `Last-Event-ID` when it reconnects.
 */
export const STREAM_CHANNELS = ['events', 'sources', 'metrics', 'alerts'];
export const SourceStatusMessageSchema = z.object({
    sourceId: z.uuid(),
    status: z.enum(SOURCE_STATUSES),
    lastError: z.string().nullable(),
    lastSuccessAt: z.iso.datetime({ offset: true }).nullable(),
});
export const MetricPointSchema = z.object({
    name: z.string(),
    value: z.number(),
    ts: z.iso.datetime({ offset: true }),
    tags: z.record(z.string(), z.string()),
});
export const MetricBatchMessageSchema = z.object({
    sourceId: z.uuid(),
    points: z.array(MetricPointSchema),
});
export const StreamMessageSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('event.created'), data: EventSchema }),
    z.object({ type: z.literal('source.status'), data: SourceStatusMessageSchema }),
    z.object({ type: z.literal('metric.batch'), data: MetricBatchMessageSchema }),
    z.object({ type: z.literal('alert.opened'), data: AlertSchema }),
    z.object({ type: z.literal('alert.fired'), data: AlertSchema }),
    z.object({ type: z.literal('alert.resolved'), data: AlertSchema }),
    /** ack, snooze, snooze expiry (step 31). */
    z.object({ type: z.literal('alert.updated'), data: AlertSchema }),
    /** Step 32: what was delivered for an alert; the web toasts on in-app and notifies natively on desktop. */
    z.object({ type: z.literal('alert.notified'), data: AlertNotifiedMessageSchema }),
]);
/** Which channel each message type belongs to. */
export const STREAM_MESSAGE_CHANNEL = {
    'event.created': 'events',
    'source.status': 'sources',
    'metric.batch': 'metrics',
    'alert.opened': 'alerts',
    'alert.fired': 'alerts',
    'alert.resolved': 'alerts',
    'alert.updated': 'alerts',
    'alert.notified': 'alerts',
};
/** Sent instead of a replay when the client's Last-Event-ID is older than the buffer. */
export const RESYNC_EVENT = 'resync';
//# sourceMappingURL=stream.js.map